module.exports = __webpack_public_path__ + "91de961a2a26d791bdc74e7741e8eb83.png";